import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import {
    Button,
    Checkbox,
    FormControlLabel,
    IconButton,
    InputAdornment,
    OutlinedInput,
    TextField,
    Typography,
    FormHelperText
} from '@mui/material';
import { useHistory, useLocation } from 'react-router';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import ReCAPTCHA from 'react-google-recaptcha';
/// Our Components
import { SignUpSecondStep } from './SignUpSecondStep';
import LoaderComponent from './LoaderComponent';
import useValidation from 'Hooks/useValidation';
// Services
import { Auth } from 'lib/api';
// Utils and Helpers
import { APP_ROUTES } from 'routes';
import signInValidation from 'helpers/signInValidation';
// Assets
import { ReactComponent as LogoConsensus } from 'assets/authentication/consensus_paystand_logo.svg';
import { ReactComponent as Logoinicio } from 'assets/authentication/LogoInicio.svg';

const useStyles = makeStyles({
    leftCarrousel: {
        backgroundColor: '#225384',
        padding: '10em'
    },
    rightSignup: {
        display: 'flex',
        justifyContent: 'center',
        padding: '6em!important'
    },
    register: {
        fontWeight: '700!important'
    },
    textField: {
        width: '100%'
    },
    inputs: {
        display: 'flex',
        rowGap: '1em',
        flexDirection: 'column',
        marginTop: '20px'
        // marginBottom: '3em'
    },
    subtitle: {
        color: 'gray'
    },
    submit: {
        display: 'flex',
        width: '100%',
        borderRadius: '20px!important',
        backgroundColor: '#1BABE2!important'
    },
    disableBlutton: {
        display: 'flex',
        width: '100%',
        borderRadius: '20px!important',
        backgroundColor: '#c2c2c2!important'
    },
    alreadyBox: {
        marginTop: '3em'
    },
    already: {
        display: 'flex',
        flexDirection: 'row'
    },
    singUpLinkBox: {
        display: 'flex',
        marginTop: '5EM',
        justifyContent: 'space-between'
    },
    singUpLink: {
        cursor: 'pointer',
        color: '#1BABE2!important'
    },
    registerText: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#182D55',
        cursor: 'pointer',
        textAlign: 'center'
    },
    termsAndServices: {
        color: '#1BABE2',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});

export const inputstyle = {
    border: 0,
    borderBottom: '1px solid #A8B6C1',
    boxSizing: 'border-box',
    fontSize: '22px',
    fontWeight: 'bold',
    height: '32px',
    lineHeight: '26.82px',
    margin: '0em .4em',
    MozAppearance: 'textfield',
    paddingLeft: '8px',
    paddingRight: 0,
    width: '36px'
};

export const SignupComponent = () => {
    const location = useLocation();
    const qs = new URLSearchParams(location.search);
    const emailInvited = qs.get('email');
    const codeValue = qs.get('value');
    const source = qs.get('source');
    const classes = useStyles();
    const history = useHistory();
    const [terms, setTerms] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [signUpStep, setSignUpStep] = useState(false);
    const nextStep = () => setSignUpStep(true);
    const backStep = () => setSignUpStep(false);
    const { form, handleChange, userSubmit, errors, submitForm } = useValidation(
        {
            first_name: '',
            last_name: '',
            email: emailInvited || '',
            password: '',
            recaptcha: '',
            source
        },
        signInValidation,
        emailInvited ? Auth.userInvited : Auth.registerUser,
        nextStep,
        codeValue
    );
    const { first_name, last_name, email } = form;

    const handleRecaptcha = e => {
        const event = {
            target: {
                name: 'recaptcha',
                value: e
            }
        };
        handleChange(event);
    };

    return (
        <>
            {submitForm && <LoaderComponent />}
            <Box display="flex" alignItems="center">
                <Box>
                    <Box display="flex" justifyContent="center">
                        {source === 'consensus2022' ? <LogoConsensus /> : <Logoinicio />}
                    </Box>
                    {source === 'consensus2022' && (
                        <Box display="flex" justifyContent="center">
                            <Typography
                                variant="subtitle1"
                                sx={{ backgroundColor: '#F7F8F9', padding: '10px 16px', borderRadius: '4px', color: '#182C55' }}>
                                Great to meet you at Consensus! Register through this special link and earn 50,000 satoshis when
                                you're approved.
                            </Typography>
                        </Box>
                    )}
                    {!signUpStep ? (
                        <form noValidate onSubmit={e => userSubmit(e)}>
                            <Box marginTop="20px">
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Typography
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '24px',
                                            color: '#182D55'
                                        }}>
                                        Register (Businesses Only)
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            width: '320px',
                                            color: '#7D95A5',
                                            marginTop: '10px'
                                        }}>
                                        Please fill out the information below to apply for your Paystand Spend account today.
                                    </Typography>
                                </Box>
                                <Box className={classes.inputs}>
                                    <TextField
                                        id="first_name"
                                        name="first_name"
                                        autoComplete="off"
                                        value={first_name}
                                        error={errors?.first_name}
                                        disabled={submitForm}
                                        placeholder="First Name*"
                                        variant="outlined"
                                        size="small"
                                        onChange={handleChange}
                                        required
                                    />
                                    <TextField
                                        id="last_name"
                                        name="last_name"
                                        autoComplete="off"
                                        value={last_name}
                                        error={errors?.last_name}
                                        disabled={submitForm}
                                        placeholder="Last Name*"
                                        variant="outlined"
                                        size="small"
                                        onChange={handleChange}
                                        required
                                    />
                                    <TextField
                                        id="email"
                                        name="email"
                                        value={emailInvited || codeValue ? emailInvited : email}
                                        error={errors?.email}
                                        disabled={emailInvited || codeValue}
                                        placeholder="Work Email Address*"
                                        variant="outlined"
                                        size="small"
                                        required
                                        sx={{
                                            backgroundColor: (emailInvited || codeValue) && '#e2e2e2'
                                        }}
                                        onChange={handleChange}
                                    />
                                    <OutlinedInput
                                        name="password"
                                        placeholder="Password*"
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                        size="small"
                                        error={errors?.password}
                                        required
                                        type={showPassword ? 'text' : 'password'}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="end">
                                                    {!showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '12px',
                                            textAlign: 'left',
                                            marginTop: '-14px',
                                            lineHeight: '16px',
                                            fontWeight: 400
                                        }}>
                                        Your password must be at least 8 characters long.
                                    </Typography>
                                </Box>
                                <FormControlLabel
                                    control={<Checkbox checked={terms} onChange={() => setTerms(!terms)} />}
                                    label={
                                        <label
                                            style={{
                                                fontSize: '14px'
                                            }}>
                                            <a
                                                href="https://www.paystand.com/corporate-card-terms-of-service"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{ textDecoration: 'none' }}
                                                className={classes.termsAndServices}>
                                                Accept all Terms of Service
                                            </a>
                                        </label>
                                    }
                                    sx={{ marginBottom: '10px' }}
                                />
                                <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '25px' }}>
                                    <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onChange={handleRecaptcha} />
                                </Box>
                                {!submitForm && terms ? (
                                    <Button
                                        className="btn-rounded"
                                        variant="contained"
                                        disabled={submitForm}
                                        fullWidth
                                        type="submit">
                                        Continue
                                    </Button>
                                ) : (
                                    <Button
                                        className="btn-rounded"
                                        variant="contained"
                                        disabled={submitForm || !terms}
                                        fullWidth
                                        sx={{ color: '#FFF!important' }}>
                                        {terms && submitForm ? 'Waiting' : 'Continue'}
                                    </Button>
                                )}
                                <Box marginTop="18px" display="flex" justifyContent="center">
                                    <label className={classes.registerText}>
                                        Already have an account?
                                        <label
                                            style={{
                                                color: '#1BABE2',
                                                fontWeight: 700,
                                                cursor: 'pointer',
                                                marginTop: '-8px'
                                            }}
                                            onClick={() => history.push(APP_ROUTES.LOGIN)}>
                                            &nbsp; Log in
                                        </label>
                                    </label>
                                </Box>
                                <Box marginTop="1em">
                                    {errors?.first_name && <FormHelperText error>{errors?.first_name}</FormHelperText>}
                                    {errors?.last_name && <FormHelperText error>{errors?.last_name}</FormHelperText>}
                                    {errors?.email && <FormHelperText error>{errors?.email}</FormHelperText>}
                                    {errors?.password && <FormHelperText error>{errors?.password}</FormHelperText>}
                                    {errors?.message && <FormHelperText error>{errors?.message}</FormHelperText>}
                                </Box>
                            </Box>
                        </form>
                    ) : (
                        <SignUpSecondStep email={email} emailInvited={emailInvited} back={backStep} />
                    )}
                </Box>
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '22px',
                    fontSize: '7px',
                    color: 'rgba(0,0,0,0.45)',
                    fontWeight: 'bold'
                }}>
                <span>&copy;PAYSTAND, INC. 2020 ALL RIGHTS RESERVED</span>
            </Box>
        </>
    );
};
